import _ from 'lodash';

import States from './states';

export default {
  'title': 'Signup',
  'description': null,
  'type': 'object',
  'properties': {
    'address': {
      'type': 'string',
      'title': 'Address'
    },
    'emailAddress': {
      'type': 'string',
      'format': 'email',
      'title': 'Email Address'
    },
    'firstName': {
      'type': 'string',
      'title': 'First Name'
    },
    'lastName': {
      'type': 'string',
      'title': 'Last Name'
    },
    'state': {
      'type': 'string',
      'title': 'State',
      'enum': _.map(States, 'abbreviation'),
      'enumNames': _.map(States, 'name')
    },
    'zipCode': {
      'type': 'string',
      'title': 'Zip Code'
    }
  },
  'required': [
    'address',
    'emailAddress',
    'firstName',
    'lastName',
    'state',
    'zipCode'
  ]
};



// WEBPACK FOOTER //
// ./src/components/container/signup/data-schema.js